$wj([42],{

/***/ 2084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlagsCharm_1 = __webpack_require__(6245);
exports.FeatureFlagsCharm = FeatureFlagsCharm_1.default;
var SkypeCharm_1 = __webpack_require__(1641);
exports.SkypeCharm = SkypeCharm_1.default;
//# sourceMappingURL=lazyCharms.js.map

/***/ }),

/***/ 6245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HeaderCharm_1 = __webpack_require__(115);
var owa_header_pane_1 = __webpack_require__(128);
var mobx_react_1 = __webpack_require__(11);
var FeatureFlagsCharm = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsCharm, _super);
    function FeatureFlagsCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm_1.default, { title: "Feature Flags", key: "featureflags", icons: { iconName: "Flag" /* Flag */ }, ariaLabel: "featureflags charm" // No need to localize as it is a DEV feature only
            , behavior: {
                paneComponent: owa_header_pane_1.FeatureFlagsPane,
                charm: 1 /* FeatureFlagsCharm */,
            } }));
    };
    FeatureFlagsCharm = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsCharm);
    return FeatureFlagsCharm;
}(React.Component));
exports.default = FeatureFlagsCharm;
//# sourceMappingURL=FeatureFlagsCharm.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.HeaderCharms.js